/* Progressive enhancement: without JS both groups remain usable links. */
if (!customElements.get('hj-occasion-tabs')) {
  customElements.define('hj-occasion-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('.hj-occasion-tabs__panel')];
      const current = new URL(location.href);
      const samePage = (href) => {
        const url = new URL(href, location.origin);
        return url.origin === current.origin && url.pathname === current.pathname &&
          url.searchParams.get('view') === current.searchParams.get('view');
      };
      this.querySelectorAll('a[href]').forEach(link => {
        if (samePage(link.href)) link.setAttribute('aria-current', 'page');
      });
      this.panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.group === panel.dataset.group).id);
      });
      // Prefer season when a landing page belongs to both groups.
      const activePanel = this.panels.find(panel => panel.querySelector('[aria-current="page"]'));
      this.select(activePanel ? activePanel.dataset.group : this.dataset.initialGroup);
      this.querySelector('[role="tablist"]').hidden = false;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab.dataset.group));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(this.tabs[next].dataset.group);
          this.tabs[next].focus();
        });
      });
    }
    select(group) {
      this.tabs.forEach(tab => {
        const active = tab.dataset.group === group;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.group !== group; });
    }
  });
}
